import { jsx } from "react/jsx-runtime";
import { createContext, useMemo, useContext } from "react";
import { useEvent } from "../../../../lib/hooks/useEvent.js";
function defaultOnError(...args) {
  console.error("[Omega] Unhandled error:", ...args);
}
const ReportingContext = createContext({ reportError: defaultOnError });
ReportingContext.displayName = "ReportingContext";
function useErrorReporting() {
  const reportingContext = useContext(ReportingContext);
  return reportingContext ?? { reportError: defaultOnError };
}
function getGlobalContext() {
  return {
    omegaVersion: "6.12.0"
  };
}
function ReportingProvider({ children, onError, onNonFatalError }) {
  const reportError = useEvent((errInfo) => {
    if (errInfo.severity === "fatal") {
      (onError ?? defaultOnError)(errInfo);
    } else {
      (onNonFatalError ?? defaultOnError)(errInfo);
    }
  });
  const reportingContext = useMemo(() => ({ reportError }), [reportError]);
  return /* @__PURE__ */jsx(ReportingContext.Provider, { value: reportingContext, children });
}
export {
  ReportingContext,
  ReportingProvider,
  defaultOnError,
  getGlobalContext,
  useErrorReporting };
//# sourceMappingURL=dist/components/VideoContextProvider/context/state/reporting.js.map